import { Skeleton } from "src/atoms/Skeleton";
import { DefaultResultsWrapper } from "../SearchResults.styled";
import { theme } from "src/theme";
import { Carousel } from "src/organisms/Carousel";

const CAROUSEL_COUNT = 2;
const ITEMS_PER_CAROUSEL = 6;

function DefaultResultsSkeleton() {
  return (
    <DefaultResultsWrapper>
      {Array.from({ length: CAROUSEL_COUNT }, (_, i) => (
        <div key={`default-result-${i}`} className="default-result-wrapper">
          <Skeleton width={120} height={20} />
          <Carousel
            items={Array.from({ length: ITEMS_PER_CAROUSEL }, (_, j) => (
              <>
                <Skeleton
                  width="100%"
                  height={i > 0 ? 120 : 60}
                  style={{ marginBlockEnd: theme.space.space16 }}
                />
                {i > 0 ? <Skeleton width="60%" height={14} /> : null}
              </>
            ))}
            fullWidthMobile
          />
        </div>
      ))}
    </DefaultResultsWrapper>
  );
}

export { DefaultResultsSkeleton };
